import { useState, useEffect } from 'react'

type ScreenType = 'Mobile' | 'TabletPortrait' | 'TabletLandscape' | 'Desktop' | 'BigDesktop'

export const MOBILE = 'Mobile'
export const TABLET_PORTRAIT = 'TabletPortrait'
export const TABLET_LANDSCAPE = 'TabletLandscape'
export const DESKTOP = 'Desktop'
export const BIG_DESKTOP = 'BigDesktop'

// TODO - TRI-3471: Stop duplicating definitons
const TABLET_PORTRAIT_MIN_WIDTH = 600
const TABLET_LANDSCAPE_MIN_WIDTH = 900
const DESKTOP_MIN_WIDTH = 1200
const BIG_DESKTOP_MIN_WIDTH = 1800

const detectScreen = (width: number): ScreenType => {
  if (width >= BIG_DESKTOP_MIN_WIDTH) return BIG_DESKTOP
  if (width >= DESKTOP_MIN_WIDTH) return DESKTOP
  if (width >= TABLET_LANDSCAPE_MIN_WIDTH) return TABLET_LANDSCAPE
  if (width >= TABLET_PORTRAIT_MIN_WIDTH) return TABLET_PORTRAIT
  return MOBILE
}

export const useWindowDimensions = () => {
  const eventTarget = window.visualViewport || window
  const { width, height } = window.visualViewport || { width: window.innerWidth, height: window.innerHeight }
  const [windowDimensions, setWindowDimensions] = useState({
    width,
    height,
    screen: detectScreen(width),
  })

  useEffect(() => {
    const handleResize = () => {
      const { width, height } = window.visualViewport || { width: window.innerWidth, height: window.innerHeight }
      setWindowDimensions({
        width,
        height,
        screen: detectScreen(width),
      })
    }

    eventTarget.addEventListener('resize', handleResize)
    return () => eventTarget.removeEventListener('resize', handleResize)
  }, [eventTarget])

  return windowDimensions
}
